/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppLocalization } from '../../models/app-localization';

export interface AppLocalizationsControllerFindAll$Params {
}

export function appLocalizationsControllerFindAll(http: HttpClient, rootUrl: string, params?: AppLocalizationsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppLocalization>>> {
  const rb = new RequestBuilder(rootUrl, appLocalizationsControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppLocalization>>;
    })
  );
}

appLocalizationsControllerFindAll.PATH = '/localizations';
